import { createApp } from "vue";
import App from "./App.vue";
import "./assets/main.css";
import "./assets/themes.css";

createApp(App).mount("#app");
